import { Union } from "../../fable-library-js.4.24.0/Types.js";
import { union_type, string_type, list_type, class_type } from "../../fable-library-js.4.24.0/Reflection.js";
import { Common_GenericOptions__AddCaseName_1505, Common_GenericOptions__AddModifiers_Z7C3AFA3, Common_GenericOptions__AddClass_Z721C83C5, Common_GenericOptions__AddProps_5A13F3A3, Common_GenericOptions_Parse_Z749EF786, Common_GenericOptions__ToReactElement_Z6A76A149, Modifier_IModifier_$reflection } from "../Common.fs.js";
import * as react from "react";
import { keyValueList } from "../../fable-library-js.4.24.0/MapUtil.js";

export class Option extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Props", "CustomClass", "is-medium", "is-large", "Modifiers"];
    }
}

export function Option_$reflection() {
    return union_type("Fulma.Section.Option", [], Option, () => [[["Item", list_type(class_type("Fable.React.Props.IHTMLProp"))]], [["Item", string_type]], [], [], [["Item", list_type(Modifier_IModifier_$reflection())]]]);
}

/**
 * Generate <section class="section"></section>
 */
export function section(options, children) {
    return Common_GenericOptions__ToReactElement_Z6A76A149(Common_GenericOptions_Parse_Z749EF786(options, (result, option) => {
        switch (option.tag) {
            case 0:
                return Common_GenericOptions__AddProps_5A13F3A3(result, option.fields[0]);
            case 1:
                return Common_GenericOptions__AddClass_Z721C83C5(result, option.fields[0]);
            case 4:
                return Common_GenericOptions__AddModifiers_Z7C3AFA3(result, option.fields[0]);
            default:
                return Common_GenericOptions__AddCaseName_1505(result, option);
        }
    }, "section"), (props_1, children_1) => react.createElement("section", keyValueList(props_1, 1), ...children_1), children);
}

